import { render, staticRenderFns } from "./MarkdownSelector.vue?vue&type=template&id=d57456e0"
import script from "./MarkdownSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports